import axios from 'axios'
import CryptoJS from 'crypto-js'
import queryString from 'query-string'

import {getCurrentLanguage} from '~/lib/i18n'

import {secureKeyManager} from './keyManager'

const requestApiList = [] // 请求中的api
const {CancelToken} = axios // cancel属性
const isIncludeType = (config) => {
  const {method, data} = config
  let cancelType = 2 // 1 首次请求有效  2：最后一次请求有效  3：不做处理
  if (method === 'post') {
    cancelType = data.cancelType || 2
    delete data.cancelType
  }
  const isInclude = [1, 2].includes(cancelType)
  return {
    cancelType,
    isInclude,
  }
}

const cancelHandle = (config, c, cancelType) => {
  if (!config) return
  const {url} = config
  const params = {...config.data, h_ts: null}
  const index = requestApiList.findIndex((i) => {
    return i.url === url && i.params === JSON.stringify(params)
  })
  // 首次请求有效，取消后面所有请求
  if (cancelType === 1) {
    if (index > -1) {
      // 后面匹配到的请求，执行取消
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      c ? c('Data request in progress...') : requestApiList.splice(index, 1)
    } else {
      // 向数组推入一个当前url记录
      requestApiList.push({
        url,
        params: JSON.stringify(params),
        c,
      })
    }
  }
  // 最后一次请求有效，取消前面所有请求
  if (cancelType === 2) {
    if (index > -1) {
      // 将最早推入的记录进行取消请求
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      c && requestApiList[index].c('Data request in progress....')
      requestApiList.splice(index, 1)
    }
    // 每次推入一条记录
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    c &&
      requestApiList.push({
        url,
        params: JSON.stringify(params),
        c,
      })
  }
}
const cancelRasetHandle = (config) => {
  if (!config) return
  const {url} = config
  const index = requestApiList.findIndex((i) => {
    return i.url === url
  })
  requestApiList.splice(index, 1)
}

const cryptoHandle = async (config: any): Promise<any> => {
  if (config.data && typeof config.data === 'object') {
    const processedData = Object.keys(config.data)
      .sort()
      .reduce((acc, key) => {
        const value = config.data[key]
        if (value !== null && value !== undefined) {
          acc[key] = typeof value === 'object' ? JSON.stringify(value) : value
        }
        return acc
      }, {} as any)
    const queryStringResult = queryString.stringify(processedData, {
      encode: true,
      skipNull: true,
      skipEmptyString: true,
    })
    const signKey = await secureKeyManager.getSecretKey()
    const stringSignTemp = queryStringResult
      ? `${queryStringResult}&key=${signKey}`
      : `key=${signKey}`
    const sign = CryptoJS.MD5(stringSignTemp).toString().toUpperCase()
    // eslint-disable-next-line no-param-reassign
    config.data.sign = sign
    return config
  }
  return config
}

axios.interceptors.request.use(async (config) => {
  const {isInclude, cancelType} = isIncludeType(config)
  // 需要设置取消拦截方式
  if (isInclude) {
    // eslint-disable-next-line no-param-reassign
    config.cancelToken = new CancelToken((c) => {
      cancelHandle(config, c, cancelType)
    })
  }
  // eslint-disable-next-line no-param-reassign
  config = await cryptoHandle(config)
  // eslint-disable-next-line no-param-reassign
  config.headers = config.headers || {}
  // eslint-disable-next-line no-param-reassign
  config.headers['X-Xc-Web-Sign'] = '1'
  // eslint-disable-next-line no-param-reassign
  config.headers['accept-language'] = getCurrentLanguage()

  return config
})
axios.interceptors.response.use(
  (res) => {
    cancelRasetHandle(res.config)
    return res.data
  },
  (error) => {
    cancelRasetHandle(error?.config)
    // 必须以 reject 透传错误，否则错误会被当成正常返回值，调用方无法感知失败
    return Promise.reject(error)
  }
)

export default axios
